import * as ForwardViewletCommand from '../ForwardViewletCommand/ForwardViewletCommand.js'

export const closeMenu = ForwardViewletCommand.forwardViewletCommand('closeMenu')
export const handlePointerOver = ForwardViewletCommand.forwardViewletCommand('handlePointerOver')
export const handleMouseOut = ForwardViewletCommand.forwardViewletCommand('handleMouseOut')
export const handleClick = ForwardViewletCommand.forwardViewletCommand('handleClick')
export const handleMouseOver = ForwardViewletCommand.forwardViewletCommand('handleMouseOver')
export const handleMenuMouseOver = ForwardViewletCommand.forwardViewletCommand('handleMenuMouseOver')
export const handleMenuClick = ForwardViewletCommand.forwardViewletCommand('handleMenuClick')
